import React from 'react'

export function Dashboard() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><rect width="11" height="11" rx="3" transform="translate(0 0)"/><rect width="11" height="11" rx="3" transform="translate(13 0)" opacity="0.23"/><rect width="11" height="11" rx="3" transform="translate(0 13)" opacity="0.23"/><rect width="11" height="11" rx="3" transform="translate(13 13)" opacity="0.23"/>
    </svg>
  )
}
